export default __webpack_public_path__ + "static/media/nounDog1614015.e7dbb426.svg";